import saml from './saml';
import samlNotify from './samlNotify';

angular
    .module('signalview.saml', ['sfx.security', 'signalboost'])
    .component('saml', saml)
    .component('samlNotify', samlNotify);
